import React from 'react';
import styled from 'styled-components';

import dualIcons from '../images/DualIcon.png';

export const ProjectFieldColab = () => {
  return (
    <ProjectField>
      <DualIcons src={dualIcons} alt="dual icons" />
      <ProjectTextWrapper>
        <ProjectText>A P-Rep project collaboration between</ProjectText>
        <ProjectTextLastLine>
          <ATag href="https://iconpreps.com/preps/reliant-node-86f917">
            ReliantNode
          </ATag>{' '}
          &{' '}
          <ATag href="https://iconpreps.com/preps/icon-ation-cc6629">
            ICONation
          </ATag>
        </ProjectTextLastLine>
      </ProjectTextWrapper>
    </ProjectField>
  );
};

export default ProjectFieldColab;

const ProjectField = styled.div`
  display: none;
  @media (max-width: 414px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-top: 1px solid #e8ebec;
    margin-top: 99.5px;
    padding-top: 19.5px;
    border-bottom: 1px solid #e8ebec;
    padding-right: 20px;
  }
`;

const DualIcons = styled.img`
  @media (max-width: 414px) {
    height: 60px;
    width: 100px;
  }
`;

const ProjectTextWrapper = styled.div`
  @media (max-width: 414px) {
    display: flex;
    flex-direction: column;
    margin-top: 13px;
    margin-right: 10px;
    margin-left: 10px;
    margin-bottom: 23px;
    text-align: center;
  }
`;

const ProjectText = styled.span`
  @media (max-width: 414px) {
    width: 271px;
    color: #010101;
    font-family: 'Avenir Next';
    font-size: 15px;
    font-weight: 500;
  }
`;

const ProjectTextLastLine = styled.span`
  @media (max-width: 414px) {
    font-family: 'Avenir Next';
    font-size: 15px;
    font-weight: 500;
  }
`;

const ATag = styled.a`
  @media (max-width: 414px) {
    text-decoration: inherit;
    color: inherit;
  }
`;
